import { render, staticRenderFns } from "./YearByUnit-Stacked.vue?vue&type=template&id=4ffb6309&"
import script from "./YearByUnit-Stacked.vue?vue&type=script&lang=js&"
export * from "./YearByUnit-Stacked.vue?vue&type=script&lang=js&"
import style0 from "./YearByUnit-Stacked.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports